import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityPage } from "../iam/account/components/AccountSecurityPage";

/**
 * Route is /account/security: the email address and password. The account layout
 * (/_app/account) validates and owns the Ory settings `flow` search param — the page
 * reads the loaded flow from context, so the route itself needs no search schema. A
 * fresh visit here mints a flow that Ory 303s back to /account/profile?flow.
 */
export const Route = createFileRoute("/_app/account/security")({
  component: AccountSecurityPage,
});
